import TextSubtitle from "apps/website/components/base/Text/TextSubtitle/TextSubtitle";
import TextBody from "apps/website/components/base/Text/TextBody/TextBody";
import Icon from "apps/website/components/base/Icon/Icon";
import cx from "apps/website/utils/misc/cx";

import { IListOption } from "../RadioButtons.types";

// Helper func to render icon based on props provided and selection state
function renderIcon(props: IListOption) {
  if (props.selected && props.selectedIcon) {
    return <Icon icon={props.selectedIcon} size="medium" className="mr-3" />;
  }
  if (props.icon) {
    return <Icon icon={props.icon} size="medium" className="mr-3" />;
  }
  return null;
}

const ListOption = (props: IListOption) => (
  <div
    data-testid="list-option-container"
    data-component={props.component ?? ListOption.name}
    data-value={props.value}
    aria-disabled={props.disabled || undefined}
    className={cx(
      "list-option flex items-start border rounded-md py-3 px-3",
      "md:rounded-lg md:py-4",
      props.selected ? "bg-black text-white" : "border border-solid border-outline-grey bg-white",
    )}
  >
    <div>
      { renderIcon(props) }
    </div>
    <div className="flex flex-col gap-1 mt-0.5">
      <TextSubtitle
        size={2}
      >
        { props.label }
      </TextSubtitle>
      { props.description && (
        <TextBody size={2} className={cx(props.selected && "text-white", "transition-none")
        }>
          { props.description }
        </TextBody>
      ) }
    </div>
  </div>
);

export default ListOption;
